import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { Documents, AddDocument, DocumentView } from "@/pages";
import React from "react";
import {
  permissionsDocumentsReadonly,
  permissionsDocumentsFull,
} from "@/utils";

export const documentRoutes: React.ReactElement[] = [
  <Route
    key="documents"
    path=""
    element={
      <ProtectedRoute
        element={<Documents />}
        codes={permissionsDocumentsReadonly}
      />
    }
  />,
  <Route
    key="add"
    path="add"
    element={
      <ProtectedRoute
        element={<AddDocument />}
        codes={permissionsDocumentsFull}
      />
    }
  />,
  <Route
    key="view"
    path="view/:id"
    element={
      <ProtectedRoute
        element={<DocumentView />}
        codes={permissionsDocumentsReadonly}
      />
    }
  />,
  <Route
    key="edit"
    path="edit/:id"
    element={
      <ProtectedRoute
        element={<AddDocument />}
        codes={permissionsDocumentsFull}
      />
    }
  />,
];
